/**
 * Claim tax back funnel events. Sent to gtag when the consent scripts have
 * loaded; always logged in development so mock sessions can be inspected.
 */

import debug from '@/helpers/debug'

export const CLAIM_FUNNEL_EVENTS = {
  PromptView: 'claim_prompt_view',
  PromptDismiss: 'claim_prompt_dismiss',
  CheckerStart: 'claim_checker_start',
  CheckerComplete: 'claim_checker_complete',
  UpgradeFromEstimate: 'claim_upgrade_from_estimate',
  GuideView: 'claim_guide_view',
  YearClaimed: 'claim_year_claimed',
  YearUnclaimed: 'claim_year_unclaimed',
} as const

export type ClaimFunnelEvent =
  (typeof CLAIM_FUNNEL_EVENTS)[keyof typeof CLAIM_FUNNEL_EVENTS]

export type ClaimFunnelParams = {
  period_key?: string
  high_rate?: boolean
  claimable_pence?: number
  prompt?: 'free' | 'paid'
}

type GtagFn = (
  command: 'event',
  eventName: string,
  params?: Record<string, unknown>
) => void

function gtag(): GtagFn | undefined {
  if (typeof window === 'undefined') return undefined
  const candidate = (window as Window & { gtag?: GtagFn }).gtag
  return typeof candidate === 'function' ? candidate : undefined
}

export function trackClaimFunnel(
  event: ClaimFunnelEvent,
  params: ClaimFunnelParams = {}
): void {
  const payload = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  )
  debug('[claim funnel]', { event, ...payload })
  gtag()?.('event', event, payload)
}
